import { finalizeOrder } from '../api/finalizeOrder';
import { showSpinner, hideSpinner } from '../helpers/spinner';

document.addEventListener('DOMContentLoaded', () => {
  const oabPage = document.querySelector('[data-oab-page]');
  if (!oabPage) return;

  const button = oabPage.querySelector('[data-oab-finalize]') as HTMLButtonElement;
  if (!button) return;

  const loadingText = button.querySelector('.loading-text');
  const defaultText = button.querySelector('.default-text');
  const successMessage = oabPage.querySelector('[data-success-message]');
  const orderNumber = document.querySelector('[data-order-number]').getAttribute('data-order-number');

  button.addEventListener('click', async () => {
    if (!orderNumber) {
      return;
    }

    console.log(orderNumber);

    try {
      button.disabled = true;
      loadingText.classList.remove('hidden');
      defaultText.classList.add('hidden');
      showSpinner(document.body);

      await finalizeOrder(orderNumber);
      hideSpinner(document.body);
      successMessage.classList.remove('hidden');
      console.log(successMessage);
      button.style.display = 'none';
    } catch (error) {
      console.error('Error finalizing order:', error);
      button.disabled = false;
      loadingText.classList.add('hidden');
      defaultText.classList.remove('hidden');
      hideSpinner(document.body);
    }
  });
});
